import React from "react";

export const Loader = () => (
  <div className="loader loader--spinner">
    <div className="double-bounce1" />
    <div className="double-bounce2" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Loader.jsx